<template>
  <div class="bg-white pr-2 pl-2 pt-4 pb-4 text-center shadow-lg">
    <div class="contract-flow-pair-overlay" v-if="isShowOverlay">
      <div class="list-container text-left">
        <div class="p-4 m-0 text-white bg-primary">
          ข้อมูลเครดิตของ {{contract.info.moneyPayload.korgoo.name}} (ผู้ขอกู้)
        </div>
        <CreditBureauList :isShowSearch="true" :userId="contract.info.moneyPayload.korgoo.id" :showPrintButton="false" :isOnlyContract="true" :isExpandable="true"></CreditBureauList>
      </div>
      <div class="button-close-container">
        <button class="btn-for-close btn btn-light" @click="isShowOverlay = false">ปิดหน้าต่างนี้</button>
      </div>
    </div>
      <h5 v-if="isEditing" class="font-weight-normal mb-1 text-danger">กำลังแก้ไขสัญญา</h5>
      <h5 v-if="isViewingEdited" class="font-weight-normal mb-1 text-primary">กำลังดูสัญญาที่ถูกแก้แล้วจากผู้ให้กู้</h5>


      <template v-if="contract.type === 'MONEY' || contract.type === 'THING'">
        <h3 v-if="contract.type === 'MONEY'" class="font-weight-normal m-0">สัญญาเงินกู้</h3>
        <h3 v-if="contract.type === 'THING'" class="font-weight-normal m-0">สัญญาซื้อขาย</h3>
        <p class="font-weight-normal m-0">#{{contract.contractNo}} - สถานะ: {{$contractStatusDict[contract.status]}}</p>
        
        <div class="container" v-if="!isCredit">
          <div v-if="contract.type === 'MONEY'" class="row">
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'KORGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.korgoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ขอกู้)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.korgoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
              <button v-if="contract.activeUserSide === 'HAIGOO' && isAllowShowingViewCreditButton" class="btn btn-sm btn-primary mt-2" @click="isShowOverlay = true">ดูเครดิต</button>
            </div>
            <div class="d-flex align-items-center justify-content-center text-primary mt-3" style="width: 28px; height: 48px;">
              →
            </div>
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'HAIGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.haigoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ให้กู้)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.haigoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
            </div>
          </div>
          <div v-if="contract.type === 'THING'" class="row">
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'KORGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.korgoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ซื้อ)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.korgoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
              <button v-if="contract.activeUserSide === 'HAIGOO' && isAllowShowingViewCreditButton" class="btn btn-sm btn-primary mt-2" @click="isShowOverlay = true">ดูเครดิต</button>
            </div>
            <div class="d-flex align-items-center justify-content-center text-primary mt-3" style="width: 28px; height: 48px;">
              →
            </div>
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'HAIGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.haigoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ขาย)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.haigoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
            </div>
          </div>
          
        </div>
      </template>
      <template v-else-if="contract.type === 'MORTGAGE'">
        <img class="my-home-icon mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/home-icon@2x.png')" />
        <h3 class="my-home-text font-weight-normal m-0">สัญญาสินเชื่อบ้าน</h3>
        <p class="my-home-text font-weight-normal m-0">{{contract.info.thingPayload.thingName}}</p>
        <p class="my-home-text font-weight-normal m-0">#{{contract.contractNo}} - สถานะ: {{$contractStatusDict[contract.status]}}</p>
        <div class="container" v-if="!isCredit">
          <div class="row">
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'KORGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.korgoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ซื้อ)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.korgoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
              <button v-if="contract.activeUserSide === 'HAIGOO' && isAllowShowingViewCreditButton" class="btn btn-sm btn-primary mt-2" @click="isShowOverlay = true">ดูเครดิต</button>
            </div>
            <div class="d-flex align-items-center justify-content-center text-primary mt-3" style="width: 28px; height: 48px;">
              →
            </div>
            <div class="col" :class="{'is-active-user': contract.activeUserSide === 'HAIGOO'}">
              <img class="rounded-circle shadow m-3 icon-48" :src="contract.info.moneyPayload.haigoo.avatarPath" />
              <p class="font-weight-normal m-0"><small>ชื่อ - นามสกุล (ผู้ขาย)</small></p>
              <p class="font-weight-normal text-primary m-0">{{contract.info.moneyPayload.haigoo.name}} <small class="active-user-indicator">(คุณ)</small></p>
            </div>
          </div>
        </div>
      
      </template>


  </div>
</template>

<script>
import CreditBureauList from './CreditBureauList'

export default {
  data: () => ({
    isShowOverlay: false,
  }),
  methods: {
  },
  props: ['contract', 'isEditing', 'isViewingEdited', 'isCredit', 'isAllowShowingViewCreditButton'],
  components: {
    CreditBureauList
  }
}
</script>

<style lang="scss">
@media only screen and (max-width: 768px) {
  .my-home-icon {
    float: left;
    margin-left:10px;
    margin-right:20px;
    margin-top:10px;
  }
  .my-home-text {
    text-align: left;
  }
}
.contract-flow-pair-overlay {
  position: fixed;
  top: 0; bottom: 0; left: 0; right: 0;
  display: flex;
  justify-content: center;
  background: rgba(0,0,0,0.8);
  z-index: 15;
  .list-container {
    width: 90%;
    height: 80%;
    margin-top: 24px;
    overflow-y: scroll;
    border-radius: 8px;
  }
  .button-close-container {
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
    .btn-for-close {

    }
  }
}
</style>
